import React, { memo } from 'react';
import 'Styles/LoadingLine.scss';

function LoadingLine() {
  return <div className="loading_line"></div>;
}

export default memo(LoadingLine);
